import { useAppSelector } from '../../../../../../../../store/hooks';
import { getReviewFiltersSelector } from '../../selectors/get-review-filters/get-review-filters.selector';

export const useGetReviewFilters = () => {
  return useAppSelector(getReviewFiltersSelector);
};
